import { render, staticRenderFns } from "./MailAssitant.vue?vue&type=template&id=aa950b30&scoped=true"
import script from "./MailAssitant.vue?vue&type=script&lang=js"
export * from "./MailAssitant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa950b30",
  null
  
)

export default component.exports